import React, { Component } from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {  Content, ContentWrapper } from './styleIndex'
import Sidebar from '../Sidebar/sidebar'
import Header from '../Header/header'
import Footer from '../Footer/footer'
import fonts from "../../fonts/fonts.js";
// import backgroundImagePc from "../../backgroundImage/image_login_pc.png";
// import backgroundImagePc from "../../backgroundImage/COMPUTADOR.png";

class index extends Component {
    render() {
        const explode = `${this.props.name}`.split(' ')
        const name = explode[0]
        return (
            <React.Fragment>               
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    {/* <Content style={{backgroundImage: `url(${backgroundImagePc})`}}> */}
                    <Content>
                        <ContentWrapper>
                            <section className="content">
                                <div className="row">
                                    <div className="col-12">
                                       
                                               
                                        <h1 style={{fontFamily:fonts.primary,padding:'15px',color:'#FFF'}}><b><br></br>{`Seja Bem Vindo ${name}`}!</b></h1>
                                        {/* <TextContent>
                                            O Projeto Tecnocoffee é uma parceria entre a Cooxupé e a 
                                            Faculdade Rehagro, com o objetivo de identificar as principais 
                                            características que interferem na produtividade do café. 
                                            Dessa forma, buscando contribuir com os produtores, 
                                            técnicos e toda a cadeia de produção do café visando 
                                            manejos que proporcionem alcançar altas 
                                            produtividades na cultura do café.
                                        </TextContent>   */}
                                    </div>
                                    {/* /.col */}
                                </div>
                                {/* /.row */}  
                            </section>                                                 
                        </ContentWrapper>
                    </Content>
                </div>
                <Footer /> 
               
            </React.Fragment>       
        )
    }
}
const mapStateToProps = state => ({
    name:state.auth.user.nome_usuario
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({}, dispatch);

export default connect(mapStateToProps,mapDispatchToProps)(index)
